export default __webpack_public_path__ + "static/media/predictive-character-seeking-sm.fb977b36.jpg";